export default __webpack_public_path__ + "static/media/535.12e1491d.png";